import { AddressCollectorBanner } from '@bridebook/web/components/bbcommon/guests/address-collector-banner';
import { useDispatch } from '@bridebook/web/lib/utils';
import { clickedToShareGuestCollectorLinkAnalytics } from '@bridebook/web/lib/guestlist/analytics/actions';
import { useCallback } from 'react';
import { ShareModalProvider } from '@bridebook/web/lib/share/share-modal-context';

const COLLECT_GUEST_INFO_POPUP_LOCATION = 'guestComms';
const SECTION = 'selectRecipients';
export const AddressCollectorBannerContainer = () => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(
      clickedToShareGuestCollectorLinkAnalytics({
        collectGuestInfoPopupLocation: COLLECT_GUEST_INFO_POPUP_LOCATION,
        section: SECTION,
        elementLabel: 'your unique link',
        element: 'addressCollectorBanner',
        category: 'Navigation',
      }),
    );
  }, [dispatch]);
  return (
    <ShareModalProvider>
      <AddressCollectorBanner
        onClick={handleClick}
        analyticsProps={{
          collectGuestInfoPopupLocation: COLLECT_GUEST_INFO_POPUP_LOCATION,
          section: SECTION,
        }}
      />
    </ShareModalProvider>
  );
};
